import {
  doc,
  getDoc,
  getDocs,
  collection,
  runTransaction,
  Timestamp,
} from 'firebase/firestore';
import { getDb, isFirebaseConfigured } from './config';

export interface GlobalBestRecord {
  time: number;
  playerName: string;
}

export async function getGlobalBest(
  level: number
): Promise<GlobalBestRecord | null> {
  const db = getDb();
  if (!db) return null;

  try {
    const docRef = doc(db, 'leaderboard', String(level));
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      return {
        time: data.time,
        playerName: data.playerName,
      };
    }
    return null;
  } catch (error) {
    console.error('Error fetching global best:', error);
    return null;
  }
}

export async function getAllGlobalBests(): Promise<
  Map<number, GlobalBestRecord>
> {
  const results = new Map<number, GlobalBestRecord>();
  const db = getDb();
  if (!db) return results;

  try {
    const querySnapshot = await getDocs(collection(db, 'leaderboard'));
    querySnapshot.forEach((doc) => {
      const level = parseInt(doc.id, 10);
      const data = doc.data();
      results.set(level, {
        time: data.time,
        playerName: data.playerName,
      });
    });
  } catch (error) {
    console.error('Error fetching all global bests:', error);
  }

  return results;
}

export async function submitGlobalBest(
  level: number,
  time: number,
  playerName: string
): Promise<boolean> {
  const db = getDb();
  if (!db) return false;

  try {
    const docRef = doc(db, 'leaderboard', String(level));

    const result = await runTransaction(db, async (transaction) => {
      const docSnap = await transaction.get(docRef);

      if (!docSnap.exists() || docSnap.data().time > time) {
        transaction.set(docRef, {
          time,
          playerName,
          timestamp: Timestamp.now(),
        });
        return true;
      }
      return false;
    });

    return result;
  } catch (error) {
    console.error('Error submitting global best:', error);
    return false;
  }
}

export { isFirebaseConfigured };
